import React, { useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import { MerchantActions, ShopActions, NotificationActions } from '../../store';
import { ShopProfile, MerchantOrAcquirerProfile, MerchantCancelletionApplying } from './components';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
})

const IdentitySelector = (state) => state.Identity;

const Profile = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const merchantActions = bindActionCreators(MerchantActions, dispatch);
    const shopActions = bindActionCreators(ShopActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);
   
    // useSelector で store の state を取得。
    const { token, userData } = useSelector(IdentitySelector);

    const [mode, setMode] = useState('');

    const { classes } = props;

    /**
     *
     * 加盟店プロフィール
     *
     * @param merchantId 加盟店ID
     * @param accountId アカウントID
     */
    const showMerchantProfile = (merchantId, accountId) => {
        // 対象の加盟店IDの加盟店情報を取得
        merchantActions.loadProfileModel(token, merchantId, accountId)
            .then(data => {
                setMode('marchant');
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    /**
     *
     * 店舗プロフィール
     *
     * @param shopId 店舗ID
     * @param accountId アカウントID
     */
    const showShopProfile = (shopId, accountId) => {
        // 対象の加盟店IDの加盟店情報を取得
        shopActions.loadProfileModel(token, shopId, accountId)
            .then(data => {
                setMode('shop');
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    /**
     *
     * 解約申請画面表示
     *
     */
    const showCancelletionApplying= (data) => {
        // 解約申請画面を表示
        setMode('cancelletion_applying');
    }

    /**
     *
     * 加盟店プロフィール再表示
     * (解約申請画面から戻り用)
     *
     */
    const showMarchantProfile = (data) => {
        // 加盟店プロフィール画面を再表示
        setMode('marchant');
    }

    useEffect(() => {
        switch (userData.role) {
            // 加盟店プロフィール画面
            case 3:
            case 4:
                showMerchantProfile(userData.org_id, userData.id);
                break;
            // 店舗プロフィール画面
            case 5:
                showShopProfile(userData.org_id, userData.id);
                break;
        }
    }, []);

    var content = <div></div>;

    if (mode == 'marchant') {
        // 加盟店プロフィール
        content = <MerchantOrAcquirerProfile onCancelletionApplying={showCancelletionApplying}/>
    }
    if (mode == 'shop') {
        // 店舗プロフィール
        content = <ShopProfile />;
    }
    if (mode == 'cancelletion_applying') {
        // 解約
        content = <MerchantCancelletionApplying onCancel={showMarchantProfile} />
    }

    return (
        <div className={classes.root} maxWidth={false}>
            {content}
        </div>
    )
}

export default withStyles(style, { withTheme: true })(Profile);
